import { useQuery } from '@apollo/client'
import { GET_ORGS } from 'domains/carrotGraph/queries/getOrgList'

/**
 * Get a list of user's orgs
 * @return {{loading, error, data, fetchMore}} loading is the loading state of the request returned by useQuery. error is the error state of the request, if any, returned by useQuery. data is an object with an orgList object; the orgList object contains an orgs object with orgs (an array of orgs) and pageInfo (which includes an endCursor that indicates the # of events retrieved so far). fetchMore is a function provided by the useQuery hook; it is the recommended way to send followup queries with Apollo Client. https://www.apollographql.com/docs/react/pagination/core-api/
 */
const useOrgList = () => {
  const variables = {}
  const { loading, error, data, fetchMore } = useQuery(GET_ORGS, {
    variables,
    fetchPolicy: 'cache-and-network',
  })
  return { loading, error, data, fetchMore }
}

export default useOrgList
